
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import attendeeService from '../services/attendeeService';

const attendeesCollectionName = 'attendees';
export const useAttendee = () => {
  return useQuery({
    queryKey: [attendeesCollectionName],
    queryFn: () => attendeeService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};


export const useAddAttendee = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: attendeeService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [attendeesCollectionName] });
    },
  }); 
};

export const useEditAttendee = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: attendeeService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [attendeesCollectionName] });
    },
  });
};


export const useDeleteAttendee = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: attendeeService.delete,
    onSuccess: () => {
      // Invalidate both attendees and deleted_attendees collections
      queryClient.invalidateQueries({ queryKey: [attendeesCollectionName] });
      queryClient.invalidateQueries({ queryKey: ['deleted_attendees'] });
    },
  }); 
};

export const useGetEventAttendees = (eventId) => {
  return useQuery({
    queryKey: [attendeesCollectionName, eventId],
    queryFn: () => attendeeService.getEventAttendees(eventId),
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useCheckAttendeeDuplicateEmailNationalIdAPONumber = () => {
  return useMutation({
    mutationFn: (data) => attendeeService.checkAttendeeDuplicateEmailNationalIdAPONumber(data)
  });
};

export const useGetAttendeesInEventWithKeyDoctorsMasterData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // Accepts an `eventId` parameter
    mutationFn: (eventId) => 
      attendeeService.getAttendeesInEventWithKeyDoctorsMasterData(eventId),
    
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [attendeesCollectionName] });
    },
  });
};


